// ---------------------------------------------------------------------------
// /smartlinks/analytics — per-offer SmartLink analytics (DASH-03, feature #115)
// ---------------------------------------------------------------------------
//
// Mirrors the pattern from `campaigns.os-targeting.tsx`:
//   - `createRoute(...)` against the scaffolded `rootRoute`
//   - `validateSearch` reserves a `?smartlinkId=` deep-link so operators can
//     open this page from a SmartLink detail view with the id prefilled
//   - keeps the page component in `@/features/smartlinks-analytics` so the
//     lane only touches files listed in the DASH-03 strict-template contract
// ---------------------------------------------------------------------------

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SmartlinkAnalyticsPage } from "@/features/smartlinks-analytics/SmartlinkAnalyticsPage";

interface SmartlinksAnalyticsSearch {
	smartlinkId?: string;
}

export const smartlinksAnalyticsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/smartlinks/analytics",
	validateSearch: (raw: Record<string, unknown>): SmartlinksAnalyticsSearch => {
		const smartlinkId = raw.smartlinkId;
		if (typeof smartlinkId === "string" && smartlinkId.trim().length > 0) {
			return { smartlinkId: smartlinkId.trim() };
		}
		return {};
	},
	component: SmartlinksAnalyticsRouteComponent,
});

export default smartlinksAnalyticsRoute;

export function SmartlinksAnalyticsRouteComponent() {
	const { smartlinkId } = smartlinksAnalyticsRoute.useSearch();
	return <SmartlinkAnalyticsPage initialSmartlinkId={smartlinkId} />;
}
